'use strict';

exports.__esModule = true;
exports['default'] = renderChildren;

var _validators = require('../../utils/validators');

function renderChildren(target) {
  (0, _validators.validateClass)(target, 'renderChildren');

  // eslint-disable-next-line
  target.prototype.render = function render() {
    return this.props.children;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/renderChildren.js
// module id = 556
// module chunks = 1